import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { env } from '@amfam/environment';
import { Coverage } from '@amfam/policy/models/lib/models/coverage';
import { PolicySummary } from '@amfam/policy/models/lib/models/policy-summary';
import { PropertyPolicy } from '@amfam/policy/models/lib/models/property-policy';
import { PolicySharedService } from '@amfam/policy/shared/lib/services/policy-shared.service';
import { CopyService } from '@amfam/shared/utility/shared-services/lib/copy/copy.service';
import { unionBy } from '@amfam/shared/utility/shared-services/lib/utils/array.utils';

import { TypedWorker } from './typed-worker';

@Injectable({
  providedIn: 'root'
})
export class PlpropertyService implements TypedWorker {
  private http = inject(HttpClient);
  private copyService = inject(CopyService);
  private policySharedService = inject(PolicySharedService);

  public getEndpoint() {
    return env.policyExperienceApi + 'product/propertypolicies/';
  }

  /*
    Expectation is that this will take the shape of the plauto api and have a status object
    and a policy object
  */
  public getPolicy(url: string, policySummary: PolicySummary): Observable<PropertyPolicy> {
    const headers = this.policySharedService.getPolicyPartnerIdHeader(
      policySummary.policyPartnerId
    );

    return this.http
      .get(url, { headers })
      .pipe(map((data: unknown) => this.loadModel(data, policySummary)));
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  public loadModel(json: any, policySummary: PolicySummary): PropertyPolicy {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let policy: any = json;
    if (json.policy) {
      policy = json.policy;
    }
    policy.namedInsuredList = [];

    if (policy.policyRoles) {
      for (let i = 0; i < policy.policyRoles.length; i++) {
        const name = policy.policyRoles[i].name;
        policy.namedInsuredList.push(name);
      }
    }

    return new PropertyPolicy(
      { ...policy, sourceSystem: policySummary.sourcePath },
      this.getCoveragesToFilter(),
      this.getCoveragesToReplace()
    );
  }

  private getCoveragesToFilter() {
    return this.copyService.getCopy('policy.filterCoverages');
  }

  private getCoveragesToReplace() {
    return this.copyService.getCopy('policy.replaceCoverages');
  }

  public getPolicyLevelCoverages(policy: PropertyPolicy): Array<Coverage> {
    return unionBy(policy.policyCoverages, policy.propertyCoverages, x => x.code);
  }
}
